/*
 * Nebula Cart CRO Enhancements
 * Mobile sticky checkout web component
 * Depends on: pubsub.js (PUB_SUB_EVENTS)
 */

/* ── Mobile Sticky Checkout Bar ───────────────────────────── */
if (!customElements.get('nebula-cart-sticky-bar')) {
  customElements.define(
    'nebula-cart-sticky-bar',
    class NebulaStickyCheckout extends HTMLElement {
      constructor() {
        super();
        this.observer = null;
        this.cartUpdateUnsubscriber = undefined;
      }

      connectedCallback() {
        this.currency = this.dataset.currency || 'USD';

        const checkoutBtn = document.querySelector('.nebula-cart__checkout-btn');
        if (!checkoutBtn) return;

        this.observer = new IntersectionObserver(
          ([entry]) => {
            this.classList.toggle(
              'nebula-cart__sticky-checkout--visible',
              !entry.isIntersecting
            );
          },
          { threshold: 0 }
        );
        this.observer.observe(checkoutBtn);

        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          const totalEl = this.querySelector('.nebula-cart__sticky-checkout-total');
          if (totalEl && event.cartData) {
            totalEl.textContent = this.formatMoney(event.cartData.total_price);
          }
        });
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
      }

      formatMoney(cents) {
        return (cents / 100).toLocaleString(Shopify.locale, {
          style: 'currency',
          currency: this.currency,
        });
      }
    }
  );
}
